const { USER_ROLE } = require('app/main/util/enums');
const authRoles = {
	superAdmin: ['superAdmin', 'super-admin'],
	admin: [USER_ROLE.ADMIN, 'superAdmin'],
	user: [USER_ROLE.ADMIN, USER_ROLE.USER, 'superAdmin'],
	instructor: [USER_ROLE.ADMIN, USER_ROLE.INSTRUCTOR, 'superAdmin'],
	participant: [USER_ROLE.PARTICIPANT],
	demo: [USER_ROLE.DEMO],
	onlyGuest: []
};

export default authRoles;
